import { Component, ViewEncapsulation, AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { ProjectQuery } from './project/state/project/project.query';
import { ProjectService } from './project/state/project/project.service';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { AuthService, LoginPayload } from './core/auth/auth.service';
import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements AfterViewInit, OnInit {
  response: any;
  returnUrl: string;
  loadingLogin = false;
  constructor(
    private _authService: AuthService,
    public router: Router,
    public projectQuery: ProjectQuery,
    private _cdr: ChangeDetectorRef,
    private _projectService: ProjectService,
    private _googleAnalytics: GoogleAnalyticsService,
    private route: ActivatedRoute
  ) {
    this._projectService.setLoading(true);
    if (environment.production) {
      this.handleGoogleAnalytics();
    }
  }
  ngOnInit(){
    //login
    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    // const currentUser = this.authenticationService.currentUserValue;
    // if (currentUser && currentUser.uid) {
    //   this.router.navigate([this.returnUrl]);
    // }
    // this._authService.login(new LoginPayload('admin', '123456', 0));
    this._projectService.getProject();
  }
  handleGoogleAnalytics() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._googleAnalytics.sendPageView(event.urlAfterRedirects);
      }
    });
  }

  ngAfterViewInit() {
    this._cdr.detectChanges();
  }
}
